import { render, staticRenderFns } from "./category-filed-bygroupId.vue?vue&type=template&id=d7cc532a&"
import script from "./category-filed-bygroupId.vue?vue&type=script&lang=js&"
export * from "./category-filed-bygroupId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports